import { STANDARD_PAGE, STANDARD_ROW_LIMIT } from '../app.models';
import * as dayjs from 'dayjs';

export enum ParamsKey {
    FILTER = 'filter',
    SORT_COLUMN = 'sortColumn',
    SORT_ASC = 'sortAsc',
    PAGE = 'page',
    ROW_LIMIT = 'rowLimit',
    USER_NAME = 'userName',
    TENANT = 'tenant',
    SERIAL_NUMBER = 'serialNumber',
    ROUTER_ID = 'routerId',
    ROUTER_TYPE = 'routerType',
    CRANE_NUMBER = 'craneNumber',
    CONNECTION_STATE = 'connectionState',
    ONLINE_STATE = 'onlineState',
    VPN_IP = 'vpnIp',
    INSTALLED_FW = 'installedFw',
    TARGET_FW = 'targetFw',
    FW_STATE = 'fwState',
    FW_RELEASED_BY = 'fwReleasedBy',
    FW_VERSION = 'fwVersion',
    FW_RELEASED_AT = 'fwReleasedAt',
    ICCID = 'iccid',
    EXPIRATION_DATE = 'expirationDate',
    HAS_SIM_CARD = 'hasSimcard',
    SEARCH = 'search',
}

export class FilterParams {
    [ParamsKey.FILTER]?: string;
    [ParamsKey.SORT_COLUMN]?: SortColumn;
    [ParamsKey.SORT_ASC]: boolean;
    [ParamsKey.PAGE]: number;
    [ParamsKey.ROW_LIMIT]?: number;
    [ParamsKey.USER_NAME]?: string;
    [ParamsKey.TENANT]?: string;
    [ParamsKey.SERIAL_NUMBER]?: string;
    [ParamsKey.ROUTER_ID]?: string;
    [ParamsKey.ROUTER_TYPE]?: number;
    [ParamsKey.CRANE_NUMBER]?: string;
    [ParamsKey.CONNECTION_STATE]?: string;
    [ParamsKey.ONLINE_STATE]?: string;
    [ParamsKey.VPN_IP]?: string;
    [ParamsKey.INSTALLED_FW]?: string;
    [ParamsKey.TARGET_FW]?: string;
    [ParamsKey.FW_STATE]?: string;
    [ParamsKey.FW_RELEASED_BY]?: string;
    [ParamsKey.FW_VERSION]?: string;
    [ParamsKey.FW_RELEASED_AT]?: Date;
    [ParamsKey.ICCID]?: string;
    [ParamsKey.EXPIRATION_DATE]?: string;
    [ParamsKey.HAS_SIM_CARD]?: boolean;
    [ParamsKey.SEARCH]?: string;

    constructor(dto: FilterParamsMap) {
        this[ParamsKey.FILTER] = dto[ParamsKey.FILTER];
        this[ParamsKey.SORT_COLUMN] = dto[ParamsKey.SORT_COLUMN];
        this[ParamsKey.SORT_ASC] = dto[ParamsKey.SORT_ASC] === 'false' ? false : true;
        this[ParamsKey.PAGE] = !Number.isNaN(+dto[ParamsKey.PAGE]) ? +dto[ParamsKey.PAGE] : STANDARD_PAGE;
        this[ParamsKey.ROW_LIMIT] = dto[ParamsKey.ROW_LIMIT] || STANDARD_ROW_LIMIT;
        this[ParamsKey.USER_NAME] = dto[ParamsKey.USER_NAME];
        this[ParamsKey.TENANT] = dto[ParamsKey.TENANT];
        this[ParamsKey.SERIAL_NUMBER] = dto[ParamsKey.SERIAL_NUMBER];
        this[ParamsKey.ROUTER_ID] = dto[ParamsKey.ROUTER_ID];
        this[ParamsKey.ROUTER_TYPE] = !Number.isNaN(+dto[ParamsKey.ROUTER_TYPE]) ? +dto[ParamsKey.ROUTER_TYPE] : undefined;
        this[ParamsKey.CRANE_NUMBER] = dto[ParamsKey.CRANE_NUMBER];
        this[ParamsKey.CONNECTION_STATE] = dto[ParamsKey.CONNECTION_STATE];
        this[ParamsKey.ONLINE_STATE] = dto[ParamsKey.ONLINE_STATE];
        this[ParamsKey.VPN_IP] = dto[ParamsKey.VPN_IP];
        this[ParamsKey.INSTALLED_FW] = dto[ParamsKey.INSTALLED_FW];
        this[ParamsKey.TARGET_FW] = dto[ParamsKey.TARGET_FW];
        this[ParamsKey.FW_STATE] = dto[ParamsKey.FW_STATE];
        this[ParamsKey.FW_RELEASED_BY] = dto[ParamsKey.FW_RELEASED_BY];
        this[ParamsKey.FW_VERSION] = dto[ParamsKey.FW_VERSION];
        this[ParamsKey.FW_RELEASED_AT] = dto[ParamsKey.FW_RELEASED_AT] ? dayjs(dto[ParamsKey.FW_RELEASED_AT]).toDate() : undefined;
        this[ParamsKey.ICCID] = dto[ParamsKey.ICCID];
        this[ParamsKey.EXPIRATION_DATE] = dto[ParamsKey.EXPIRATION_DATE];
        this[ParamsKey.HAS_SIM_CARD] =
            dto[ParamsKey.HAS_SIM_CARD] !== undefined && dto[ParamsKey.HAS_SIM_CARD] !== ''
                ? dto[ParamsKey.HAS_SIM_CARD] === 'false'
                    ? false
                    : true
                : undefined;
        this[ParamsKey.SEARCH] = dto[ParamsKey.SEARCH];
    }
}

export type SortColumn = string;

export type FilterParamsMap = {
    [key in ParamsKey]?: any;
};

export enum RouterActionTypes {
    NAVIGATE = '@liebherr/router/navigate',
    FORWARD = '@liebherr/router/forward',
    BACKWARD = '@liebherr/router/backward',
}
